<form [formGroup]="passwordForm"
  (ngSubmit)="submit()"
  novalidate>
  <div class="tw-flex tw-flex-col gd-global-material-dialog-padding">

    <h2 class="mat-h2">Session Expired</h2>
    @if (!ssoUser) {
      <section>
        <p>Please enter your password to continue working</p>
        <mat-form-field class="gd-extend-session-dialog__input" appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput
            type="password"
            formControlName="password">
            @if (passwordForm.get('password').hasError('required')) {
              <mat-error>
                Required
              </mat-error>
            }
            @if (passwordForm.get('password').hasError('invalidPassword')) {
              <mat-error
                >
                Invalid password
              </mat-error>
            }
          </mat-form-field>
        </section>
      } @else {
        <section class="tw-flex tw-flex-col tw-gap-5 tw-mb-5">
          <span>Please sign in with SSO to continue working</span>
        </section>
      }


      <!-- buttons -->
      <section class="tw-flex tw-justify-end tw-items-end tw-gap-3 tw-flex-100">
        @if (makingRequest) {
          <div class=".gd-extend-session-dialog__loader"
            >
            <mat-spinner mode="indeterminate"
              diameter="30">
            </mat-spinner>
          </div>
        }
        @if (!ssoUser) {
          <button
            mat-raised-button
            color="primary"
            type="submit"
            class="gd-change-password-dialog-buttons--save"
            [disabled]="passwordForm.invalid || makingRequest">
            Continue working
          </button>
        } @else {
          <button mat-raised-button
            color="primary"
            type="button"
            class="tw-flex tw-justify-center"
            (click)="samlLogin()">
            <mat-icon matSuffix
              class="gd-reset-password__show-hide-icon"
              fontSet="fal"
            fontIcon="fa-key"></mat-icon>
            <span>
              Continue with SSO
            </span>
          </button>
        }
        <button mat-button
          color="danger"
          (click)="exit()"
          mat-dialog-close>
          Log out
        </button>
      </section>

    </div>
  </form>
